import { useEffect, useMemo, useState } from "react"
import { HoardOrder } from "../../../state/types"
import { HoardStatusPDFPage } from "./hoardStatusPDFPage"
import { ItemsPDFWrapper } from '../../../../../features/ui'
import { CodedDataType } from '../../../../../tables'
import { Item } from "../../../../operations"
import { DeliveryOrder, useDeliveryOrderLoaders } from "../../../../deliveries"
import { hoardHelpers } from "../../../hooks/hoardHooks"
import { HoardStatusItem, HoardStatusSection } from "./types"

type Props = {
    id: string
    hoard: HoardOrder
    previewMode?: boolean
}

export const HoardStatusPDF = (props: Props) => {
    const { id, hoard, previewMode } = props

    const [deliveryOrders, setDeliveryOrders] = useState<DeliveryOrder[]>([])

    const deliveryOrderLoaders = useDeliveryOrderLoaders()

    useEffect(() => {
        deliveryOrderLoaders().loadOperationDeliveryOrders(hoard.id).then(setDeliveryOrders)
    }, [hoard])

    // One list with the section of each item, so the pages can be split as usual
    const statusItems: HoardStatusItem[] = useMemo(() => {
        const { delivered, pending, returned } = hoardHelpers.getFinancialHoardItemsByStatus(hoard, deliveryOrders)
        const withSection = (items: Item[], section: HoardStatusSection) => items.map(item => ({ ...item, section }))
        return [
            ...withSection(delivered, HoardStatusSection.DELIVERED),
            ...withSection(pending, HoardStatusSection.PENDING),
            ...withSection(returned, HoardStatusSection.RETURNED)
        ]
    }, [hoard, deliveryOrders])

    const renderPDFPage = (
        pageIndex: number,
        dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => (
        <HoardStatusPDFPage
            pageIndex={pageIndex}
            hoard={dataType as HoardOrder}
            items={items as HoardStatusItem[]}
            pagesAmount={pagesAmount}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            dataType={hoard}
            items={statusItems}
            previewMode={previewMode}
            renderPDFPage={renderPDFPage}
        />
    )
}
